var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIc24Plane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6 2C9.34388 2 9.09826 2.10174 8.91716 2.28284L7.76014 3.43986C7.66079 3.53921 7.5166 3.57915 7.38029 3.54507L2.8 2.4L2.39242 2.80758C2.23621 2.96379 2.23621 3.21705 2.39242 3.37326C2.42282 3.40366 2.45793 3.42896 2.49638 3.44819L6 5.2L4.4 6.8H2.64721C2.4957 6.8 2.3572 6.8856 2.28944 7.02111L2 7.6L3.6 8.4L4.4 10L4.97889 9.71056C5.1144 9.6428 5.2 9.5043 5.2 9.35279V7.6L6.8 6L8.55181 9.50362C8.65061 9.70121 8.89087 9.7813 9.08847 9.68251C9.12692 9.66328 9.16202 9.63798 9.19242 9.60758L9.6 9.2L8.45493 4.61971C8.42085 4.4834 8.46079 4.33921 8.56014 4.23986L9.71716 3.08284C9.89826 2.90174 10 2.65612 10 2.4C10 2.17909 9.82091 2 9.6 2Z",
    fill: "#438FFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc24Plane);
export default __webpack_public_path__ + "static/media/ic24-plane.822ad8146007dee2728b2e2858a24597.svg";
export { ForwardRef as ReactComponent };